/**
 * @file: NativeSupport.android.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { NativeModules } from 'react-native';
import RNFetchBlob from 'rn-fetch-blob';
import { NativeSupportModule } from './types';

const { EulerNativeSupportModule } = NativeModules;

export const NativeSupport: NativeSupportModule = {
  async canRequestPackageInstalls(): Promise<boolean> {
    if (!EulerNativeSupportModule) {
      return true;
    }
    // eslint-disable-next-line @typescript-eslint/return-await
    return await EulerNativeSupportModule.canRequestPackageInstalls();
  },

  async openManageUnknownAppSourcesSettings() {
    if (!EulerNativeSupportModule) {
      return;
    }
    await EulerNativeSupportModule.openManageUnknownAppSourcesSettings();
  },

  async actionViewIntent(filePath: string, mimeType: string): Promise<any> {
    if (!EulerNativeSupportModule) {
      return await RNFetchBlob.android.actionViewIntent(filePath, mimeType);
    }

    // eslint-disable-next-line @typescript-eslint/return-await
    return await EulerNativeSupportModule.actionViewIntent(filePath, mimeType);
  },
};
